import React from 'react'

function CheckValidationInput({ setShowErrorInputField, getErrorMsg, componentType }) {
    return (
        <div className="published_Deative_transprant_body" style={{ zIndex: "999" }}>
            <div className="published_Deative_preview_container">
                {/* <img
                    className="deactive_closeBtn"
                    src="/images/cross-circle3.svg"
                    alt="close"
                    // onClick={() => close(false)}
                /> */}
                <div className="col-12 deactivate_msg" style={{ fontSize: "18px" }}>
                    {getErrorMsg && `Please review the [${getErrorMsg}]`}
                </div>
                <div className="row col-12 publish_deactive_btnBox" style={{ width: "300px" }}>
                    <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={() => setShowErrorInputField(false)}>
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CheckValidationInput